import Big from "big.js";

export class MoneyUtils {
    static getNettoFromBrutto(brutto: number, percent: number) {
        const bigBrutto = new Big(brutto);
        return bigBrutto
            .mul(new Big(100))
            .div(new Big(100 + percent))
            .round(0, Big.roundHalfUp)
            .toNumber();
    }

    /**
     * Tax on top of a net amount (e.g. the synthesized §13b / ig-Erwerb USt/VSt legs).
     * Big.js round-half-away-from-zero keeps ±x,5 ct symmetric, so a Storno counterweight
     * inverts the original exactly; exact decimal arithmetic also keeps non-dyadic percents
     * (10,7 % / 5,5 % §24 UStG) deterministic at the midpoint.
     */
    static getTaxOnTop(netto: number, percent: number) {
        return new Big(netto).mul(new Big(percent)).div(new Big(100)).round(0, 1).toNumber();
    }
}
